import { ReactComponent as SmallTick } from '@assets/svg/small-tick.svg';
import { ReactComponent as SmallDash } from '@assets/svg/small-dash.svg';
import { CheckboxIconProps } from '@mantine/core';
import React from 'react';

function CheckIcon(props: CheckboxIconProps) {
  const { indeterminate, ...rest } = props;
  if (indeterminate) {
    return <SmallDash {...rest} />;
  }
  return <SmallTick {...rest} />;
}

export default React.memo(CheckIcon);
